import { SVGs } from "../../assets";
import Button from "../button";
import Text from "../text";
import React from "react";

const Success = ({ desc = "", icon = SVGs.balloons, button = {} }) => {
  return (
    <div>
      <img src={icon} />
      <Text className="m-20-t" color="secondary" children={desc} />
      <Button
        type="primary"
        minWidth={"12rem"}
        className="m-35-t"
        {...button}
      />
    </div>
  );
};

export default Success;
